import React, { useState, useMemo } from "react";
import {
  DragDropContext,
  Droppable,
  Draggable
} from "@hello-pangea/dnd";
import { Input, Card, CardBody, CardHeader, Row, Col, Button } from "reactstrap";
import "./ItemPicker.scss";

const ItemPickerDndElite = ({
  options = [],
  value = [],
  onChange,
  titleLeft = "Available",
  titleRight = "Selected",
  leftPlaceholder="Search skills...",
  rightPlaceholder="Search assigned...",
  onSubmit,
}) => {
  const [searchLeft, setSearchLeft] = useState("");
  const [searchRight, setSearchRight] = useState("");

  const availableItems = useMemo(() => {
    const selectedIds = new Set(value.map(v => v.value));
    return options.filter(
      o =>
        !selectedIds.has(o.value) &&
        o.label.toLowerCase().includes(searchLeft.toLowerCase())
    );
  }, [options, value, searchLeft]);

  const selectedItems = useMemo(() => {
    return value.filter(v =>
      v.label.toLowerCase().includes(searchRight.toLowerCase())
    );
  }, [value, searchRight]);

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;

    // LEFT → RIGHT
    if (
      source.droppableId === "available" &&
      destination.droppableId === "selected"
    ) {
      const item = availableItems[source.index];
      if (!item) return;
      onChange([...value, item]);
    }

    // RIGHT → LEFT
    if (
      source.droppableId === "selected" &&
      destination.droppableId === "available"
    ) {
      onChange(value.filter((_, i) => i !== source.index));
    }

    // REORDER RIGHT
    if (
      source.droppableId === "selected" &&
      destination.droppableId === "selected"
    ) {
      const items = Array.from(value);
      const [moved] = items.splice(source.index, 1);
      items.splice(destination.index, 0, moved);
      onChange(items);
    }
  };

  const handleRemoveSelected = (index) => {
    const updated = value.filter((_, i) => i !== index);
    onChange(updated);
  };


  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="item-picker-elite">

        {/* LEFT */}
        <div className="picker-col">
          <Card className="picker-card">
            <CardHeader>
              {/* <strong>{titleLeft}</strong> <span>Drag & Drop into right side </span> */}
              {/* <div className="picker-header__title">
                {titleLeft}
              </div> */}

              <div className="picker-header__subtitle">
                Drag & drop items to the right panel
              </div>
              <Input
                bsSize="sm"
                placeholder={leftPlaceholder}
                value={searchLeft}
                onChange={(e) => setSearchLeft(e.target.value)}
              />
            </CardHeader>

            <CardBody>
              <Droppable droppableId="available">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="drop-area"
                  >
                    {availableItems.map((item, index) => (
                      <Draggable
                        key={item.value}
                        draggableId={String(item.value)}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={`drop-item ${
                              snapshot.isDragging ? "dragging" : ""
                            }`}
                          >
                            {item.label}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </CardBody>
          </Card>
        </div>

        {/* RIGHT */}
        <div className="picker-col">
          <Card className="picker-card">
            {/* <CardHeader>
              <div className="picker-header__title">
                {titleRight}
              </div>   
            </CardHeader> */}

            <CardBody>
              <Droppable droppableId="selected">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="drop-area selected"
                    style={{
                      minHeight: "525px", // 👈 important
                      background: snapshot.isDraggingOver ? "#f5f5f5" : ""
                    }}
                  >
                    {/* {selectedItems.length === 0 && (
                      <div className="empty-hint">
                        Drop skills here
                      </div>
                    )}

                    {selectedItems.map((item, index) => (
                      <Draggable
                        key={String(item.value)}
                        draggableId={String(item.value)}
                        index={index}
                        
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="drop-item active"
                          >
                            {item.label}
                          </div>
                        )}
                      </Draggable>
                    ))} */}

                    {selectedItems.map((item, index) => (
                      <Draggable
                        key={String(item.value)}
                        draggableId={String(item.value)}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="drop-item active"
                          >
                            <div className="drop-item-content">
                              <div className="drop-item-label">{item.label}</div>
                              {item.description && (
                                <div className="drop-item-description">{item.description}</div>
                              )}
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>

            </CardBody>
          </Card>
          <Row>
            <Col className="d-flex justify-content-end align-items-center">
              <Button type="submit" className="btn btn button-save d-flex align-items-center gap-2" onClick={() => onSubmit(value)}>
                <i className="fas fa-save " /> Save & Continue
              </Button>
            </Col>
          </Row>
        </div>

      </div>
    </DragDropContext>
  );
};

export default ItemPickerDndElite;
